import { apiClient } from "@/services/api";

const state = () => ({
    cronometrosProducao: null,
    cronometroEmExibicao: null,
    flg_favorita: false,
    filtroCronometros: localStorage.getItem("@socialcam/filtro_texto_cronometro") ? localStorage.getItem("@socialcam/filtro_texto_cronometro") : null,
})

const getters = {
    getterCronometrosProducao: state => {
        return state.cronometrosProducao
    },
    getterCronometroEmExibicao: state => {
        return state.cronometroEmExibicao
    },
    getterFiltroCronometros: state => {
        return state.filtroCronometros
    }
}

const actions = {
    async getCronometrosByProducao({ commit }, payload) {
        const { cod_producao, filtro_texto, flg_favorita, page, size, cod_pasta } = payload;

        await apiClient.get(
            `cronometro/getByProducao/${cod_producao}?page=${page ? page : ''}&size=${size ? size : ''}&filtro_texto=${filtro_texto ? filtro_texto : ''}&flg_favorita=${flg_favorita}&cod_pasta=${cod_pasta}`
        ).then((response) => {
            commit('setCronometrosProducao', response.data.cronometros)
        }).catch(error => {
            console.error(error)
        })
    },
    async getCronometroEmExibicao({ commit }, payload) {
        const { cod_producao } = payload;
        await apiClient.get(
            `cronometro/exibicao/${cod_producao}`
        ).then( (response) => {
            commit('setCronometroEmExibicao', response.data);
        }).catch(error => {
            console.error(error);
        })
        //
    },
    setFlgFavorita({ commit }, value) {
        try {
            commit('setFlgFavorita', value)
        } catch (error) {
            console.error(error)
        }
    },
    setFiltroCronometros({ commit }, value) {
        try {
            commit('setFiltroCronometros', value)
        } catch (error) {
            console.error(error)
        }
    },
}

const mutations = {
    setCronometrosProducao(state, value) {
        state.cronometrosProducao = value
    },
    // Optimistic removal: drop a cronômetro from the received list immediately
    // (e.g. when it is sent to "em exibição") without waiting for a refetch.
    removeCronometroProducao(state, id) {
        const list = state.cronometrosProducao
        if (!list || !Array.isArray(list.items)) return
        list.items = list.items.filter((cronometro) => cronometro.id !== id)
        if (typeof list.totalItems === "number") {
            list.totalItems = Math.max(0, list.totalItems - 1)
        }
    },
    setCronometroEmExibicao(state, value) {
        state.cronometroEmExibicao = value
    },
    setFlgFavorita(state, value) {
        state.flg_favorita = value
    },
    setFiltroCronometros(state, value) {
        state.filtroCronometros = value
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}